export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_LOAD_USERS = "AUTH_LOAD_USERS";
export const AUTH_LOAD_ERROR = "AUTH_LOAD_ERROR";
export const AUTH_LOGOFF = "AUTH_LOGOFF";

export const TASK_LOAD = "TASK_LOAD";
export const TASK_ERROR = "TASK_ERROR";
export const TASK_SEND = "TASK_SEND";
export const TASK_LOAD_COUNT = "TASK_LOAD_COUNT";